import { useSearchParams } from 'react-router-dom';

import type { IAppRegion } from '~/lib/appSettings';
import { ResetPasswordPage } from '~/components/pages/ResetPasswordPage';
import { PageTemplate } from '~/components/templates/PageTemplate';

export const ResetPasswordRoute: React.FC = () => {
  const [searchParams] = useSearchParams();
  const nextUrl = searchParams.get('nextUrl') || undefined;
  const appRegion = (searchParams.get('appRegion') || undefined) as
    | IAppRegion
    | undefined;
  const email = searchParams.get('email') || undefined;
  const token = searchParams.get('token') || undefined;

  return (
    <PageTemplate>
      <ResetPasswordPage
        nextUrl={nextUrl}
        defaultValues={{ appRegion, email, token }}
      />
    </PageTemplate>
  );
};
